const get = require('lodash/get')
const { parse } = require('../../../tools/smart-id')
const createSnapshot = require('../../../shipment/shipment-create-snapshot')
const { SUBORDER_STATUS, PRIOR_STATUS_MAPPING } = require('../../constants')
const { SHIPMENT_STATUS } = require('../../../shipment/constants')

const STATUS_RANK = {
  [SHIPMENT_STATUS.NEW]: 0,
  [SHIPMENT_STATUS.PACKED]: 1,
  [SHIPMENT_STATUS.SENT]: 2,
  [SHIPMENT_STATUS.ARRIVED]: 3,
  [SHIPMENT_STATUS.RECEIVED]: 4
}

exports.moveShipmentStatus = async function (state, {
  suborderId,
  status = SUBORDER_STATUS.received,
  priorStateSnapshot,
  shipmentCount,
  externalShipmentId,
  shipmentNumber,
  dryRun = false
}) {
  const orderSnapshot = await state.dal.order.getSuborder(state, {suborderId})

  if (!priorStateSnapshot) {
    const shipmentSnapshots = await state.dal.order.getShipmentsOnOrder(state, orderSnapshot._id)

    const priorStatus = PRIOR_STATUS_MAPPING[status]
    priorStateSnapshot = shipmentSnapshots.find(snapshot => parse(snapshot._id).status === priorStatus && snapshot.type === 'snapshot')

    if (priorStateSnapshot) {
      const { shipmentNo } = parse(priorStateSnapshot._id)
      const requestedRank = STATUS_RANK[status] != null ? STATUS_RANK[status] : -1

      const relevantSnapshots = shipmentSnapshots.filter(
        snapshot => snapshot.type === 'snapshot' && parse(snapshot._id).shipmentNo === shipmentNo
      )

      const maxExistingRank = relevantSnapshots.reduce((max, snapshot) => {
        const rank = STATUS_RANK[parse(snapshot._id).status]
        return rank != null && rank > max ? rank : max
      }, -1)

      if (maxExistingRank > requestedRank) {
        const mostAdvancedStatus = Object.keys(STATUS_RANK).find(s => STATUS_RANK[s] === maxExistingRank)
        const logger = state.logger || console
        logger.warn({
          code: 'snapshot-creation-skipped',
          suborderId,
          shipmentNo,
          requestedStatus: status,
          mostAdvancedStatus,
          reason: `Skipping ${status} snapshot: a more advanced ${mostAdvancedStatus} snapshot already exists`
        })
        return relevantSnapshots.find(snapshot => parse(snapshot._id).status === mostAdvancedStatus)
      }
    }
  }

  const shipmentSnapshot = createShipmentSnapshot(orderSnapshot, priorStateSnapshot, status, shipmentCount, externalShipmentId, shipmentNumber, dryRun)
  return createSnapshot(state, { ...shipmentSnapshot, allowConflict: true })
}

function createShipmentSnapshot (orderSnapshot, shipmentSnapshot, status, shipmentCount, externalShipmentId, shipmentNumber, dryRun) {
  const shipmentNo = shipmentNumber || getShipmentNumber(shipmentSnapshot)
  const routeId = get(orderSnapshot, 'routeId')
  const oneShipmentNumber = get(orderSnapshot, 'additionalData.shipmentNumber')
  return {
    origin: orderSnapshot.supplierId,
    destination: orderSnapshot.destinationId,
    // VAN store api expects YYYY-MM-DD
    date: orderSnapshot.createdAt.split('T')[0],
    shipmentTypeId: `allocated:${orderSnapshot.funderId}`,
    funderId: orderSnapshot.funderId,
    orderId: orderSnapshot._id,
    programId: orderSnapshot.programId,
    routeId,
    shipmentNo,
    status,
    counts: shipmentCount && Object.keys(shipmentCount).length > 0
      ? shipmentCount
      : getCounts(shipmentSnapshot),
    removePaymentType: true,
    doCheckSent: false,
    dryRun,
    externalShipmentId: externalShipmentId || oneShipmentNumber
  }
}

function getShipmentNumber (newShipmentSnapshot = {}) {
  if (!newShipmentSnapshot._id) return null
  const {shipmentNo} = parse(newShipmentSnapshot._id)
  return shipmentNo
}

function getCounts (newShipmentSnapshot) {
  // ignore snapshot comment docs
  if (!newShipmentSnapshot) {
    return {}
  }
  return Object.keys(newShipmentSnapshot.counts)
    .reduce((acc, batchId) => {
      acc[batchId] = {
        quantity: newShipmentSnapshot.counts[batchId].quantity,
        checked: true
      }
      return acc
    }, {})
}
